// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import Ractive from 'ractive';
import { InvestingButton } from './Controls/elements/InvestingButton';
import { InvestingLoginScreen } from './Screens/InvestingLoginScreen';
import { InvestingTextBox } from './Controls/elements/InvestingTextBox';
import { InvestingForgotPasswordScreen } from './Screens/InvestingForgotPasswordScreen';
import { InvestingChangePasswordScreen } from './Screens/InvestingChangePasswordScreen';
import { InvestingComboBox } from './Controls/elements/InvestingComboBox';
import { InvestingCheckBox } from './Controls/elements/InvestingCheckBox';
import { InvestingMenu } from './Controls/elements/InvestingMenu';
import { InvestingPasswordTextBox } from './Controls/elements/InvestingPasswordTextBox';
Ractive.components.investingButton = InvestingButton;
Ractive.components.investingLoginScreen = InvestingLoginScreen;
Ractive.components.investingTextBox = InvestingTextBox;
Ractive.components.investingForgotPasswordScreen = InvestingForgotPasswordScreen;
Ractive.components.investingChangePasswordScreen = InvestingChangePasswordScreen;
Ractive.components.investingComboBox = InvestingComboBox;
Ractive.components.investingCheckBox = InvestingCheckBox;
Ractive.components.investingMenu = InvestingMenu;
Ractive.components.investingPasswordTextBox = InvestingPasswordTextBox;
